import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

interface CodeLabelProps {
  active?: boolean;
  isCountry?: boolean;
}

export const CodeLabel = styled("span")(
  ({ active = false, isCountry = false }: CodeLabelProps) => ({
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: isCountry ? 600 : 700,
    lineHeight: "16px",
    // eslint-disable-next-line no-nested-ternary
    color: isCountry
      ? active
        ? colors.brandBlue400
        : colors.gray600
      : active
      ? colors.brandBlue600
      : colors.gray800,
  })
);

interface DateLabelProps {
  active?: boolean;
  light?: boolean;
}

export const DateLabel = styled("span")(({ active, light }: DateLabelProps) => ({
  color: active ? colors.brandBlue600 : colors.gray600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: light ? 400 : 700,
  letterSpacing: "0.4px",
  lineHeight: "16px",
  textTransform: light ? "none" : "uppercase",
}));

export const useStyles = makeStyles(() => ({
  atdMobile: {
    display: "flex",
    flexDirection: "row",
    gap: "2px",
  },

  card: {
    boxShadow: "none",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minWidth: "212px",
    transform: "translate(-40%, -40%)",
  },

  cardContent: {
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
    justifyContent: "center",
    padding: "4px 12px",
  },
  separator: {
    borderTop: `1px solid ${colors.gray200}`,
    padding: "0px !important",
    margin: "2px 0px !important",
    width: "100%",
  },
  cardHeader: {
    padding: "8px 12px",
    "& > .MuiCardHeader-content > .MuiCardHeader-title": {
      fontFamily: "Manrope",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 600,
      letterSpacing: "0.1px",
      lineHeight: "20px",
      color: colors.brandBlue700,
      textDecorationLine: "underline",
      cursor: "pointer",
    },
    "& > .MuiCardHeader-content > .MuiCardHeader-subheader": {
      fontFamily: "Manrope",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
      letterSpacing: "0.4px",
      lineHeight: "16px",
      color: colors.gray700,
    },
    "& > .MuiCardHeader-action": {
      margin: "0px",
      alignSelf: "center",
    },
  },

  datesContainer: {
    alignItems: "start",
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    margin: 0,
  },

  infoContainer: {
    alignItems: "center",
    display: "flex",
    gap: "0 8px",
    height: "100%",
    position: "relative",
    "@media": {
      flexDirection: "column",
      width: "100%",
    },
  },

  map: {
    borderRadius: "4px",
    height: "100%",
    width: "100%",
    "& > div": {
      borderRadius: "8px !important",
    },
    "& .gm-svpc": {
      display: "none",
    },
    "& .gm-style-mtc": {
      display: "none",
    },
    "& .gm-fullscreen-control": {
      display: "none",
    },
  },

  portsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "44px 0",
    justifyContent: "space-between",
    paddingLeft: "16px",
    minHeight: "320px",

    "@media": {
      flexDirection: "row",
      gap: "0px",
      height: "100%",
      minHeight: "0px",
      paddingLeft: "0px",
      width: "100%",
    },
  },

  shipmentPredictions: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    justifyContent: "space-between",
  },
  portsItems: {
    display: "flex",
    flexDirection: "row",
    gap: "2px",
    alignItems: "center",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 700,
    letterSpacing: "0.5px",
    lineHeight: "16px",
    color: colors.gray600,
    width: "50%",
  },

  cardActions: {
    background: colors.brandBlue600,
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& > div": {
      fontFamily: "Manrope",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 600,
      letterSpacing: "0.5px",
      lineHeight: "16px",
      color: colors.blue25,
    },
  },
  loading: {
    height: "100px",
  },
}));
